module.exports = __webpack_public_path__ + "img/product_3.da49e28.webp";